import { ReactNode } from 'react';

// eslint-disable-next-line no-restricted-imports
import { Tab } from '@mui/material';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

interface StyledTabProps {
  label: ReactNode;
  isError?: boolean;
}

export const TabStyled = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme, isError }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  textTransform: 'none',
  textWrap: 'nowrap',
  ...theme.typography.bodySemiBold,
  color: isError ? Colors.red : 'inherit',
  padding: 0,
  minWidth: 'auto',
  flex: 'none',
  transition: theme.transitions.create(['color']),

  minHeight: 36,

  '&.Mui-selected': {
    color: isError ? Colors.red : 'inherit',
  },

  '&:hover': {
    color: Colors.hover,
  },
}));
